export default "__VITE_ASSET__DeLkEMNl__"